import React from "react";
import ReactDOM from "react-dom";

const BUILD_TARGETS = [
  {
    name: "search",
    path: "./SearchApp",
    appRoot: "apartmentSearchApp",
  },
  {
    name: "form",
    path: "./FormApp",
    appRoot: "reservationFormApp",
  },
  {
    name: "listing",
    path: "./ListingApp",
    appRoot: "apartmentListingApp",
  },
];

const { path, appRoot } = BUILD_TARGETS.find(
  (target) => process.env.REACT_APP_BUILD_TARGET === target.name
);

import(`${path}`).then(({ default: BuildTarget }) => {
  ReactDOM.render(
    <React.StrictMode>
      <BuildTarget />
    </React.StrictMode>,
    document.getElementById(appRoot)
  );
});
